import { jwtDecode } from 'jwt-decode'

interface JWTPayload {
  exp: number
  iat?: number
  userId?: number
  email?: string
  [key: string]: unknown
}

/**
 * Check if JWT token is expired
 * @param token - JWT token string
 * @returns true if token is expired or invalid, false if valid
 */
export function isTokenExpired(token: string | null): boolean {
  if (!token) {
    return true
  }

  try {
    const decoded = jwtDecode<JWTPayload>(token)
    const currentTime = Date.now() / 1000
    const expiryTime = decoded.exp

    if (expiryTime) {
      const expired = expiryTime < currentTime

      if (expired) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } catch (error) {
    // If decoding fails, consider token as expired/invalid
    // eslint-disable-next-line no-console
    console.error('[tokenCheck] Error decoding token:', error)
    return true
  }
}
